import { Components, Theme } from '@mui/material/styles'

export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '4px',

      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    }),
  },
}
